import _ from 'lodash'
import { createAction, createReducer } from 'redux-act'
import axios from 'axios'
import qs from 'qs'
import message from 'antd/lib/message'
import l8n from 'l8n'

import { addSubmitForm, deleteSubmitForm, getCurrentUser, setUser } from 'ducks/app'
import { baseUrl } from 'scripts/env';
import {resetSendStatus} from "./email_verification";
import Url from 'url-parse'

export const REDUCER = 'settings'
const NS = `@@${REDUCER}/`

export const setInitialsState = createAction(`${NS}SET_INITIAL_STATE`)

export const sendRequest = createAction(`${NS}SEND_REQUEST`)
export const sendSuccess = createAction(`${NS}SEND_SUCCESS`)
export const sendFailure = createAction(`${NS}SEND_FAILURE`)

export const change = createAction(`${NS}CHANGE`)

const initialState = {
  isLoading: false,
  data: {
    display_name: {value: null},
    site_url: {value: null},
    email: {value: null},            
    password: {value: null},
    current_password: {value: null},
  }      
}

export const send = async (details, dispatch, getState) => {
  const parsed_url = new Url(details.site_url, details.site_url);
  const slashes = /\/+$/;
  details.site_url = parsed_url.hostname.replace(slashes, '') || parsed_url.href.replace(slashes, '') || null

  dispatch(sendRequest())
  var response = await axios({
      method: 'POST',
      url: `${baseUrl}/user/settings`,
      data: qs.stringify(details)
  })

  if (_.get(response, 'data.ok', false) === false) {
      dispatch(sendFailure())
      message.error(l8n.req_not_saved);
      return false
  }

  dispatch(sendSuccess())
  message.success(l8n.req_saved)

  const params = _.pick(details, ['display_name', 'site_url', 'email'])
  const state = getState()
  const user = getCurrentUser(state)
  if (params.email !== user.email) {
    params.email_verified = false
    dispatch(resetSendStatus())
  }
  dispatch(setUser(params))
  return true
}

export const submit = settings => async (dispatch, getState) => {
  dispatch(addSubmitForm(REDUCER))
  await send(settings, dispatch, getState)
  dispatch(deleteSubmitForm(REDUCER))
}

export default createReducer(
  {
    [setInitialsState]: (state, flatData) => { 
      // Добавляем уровень вложенности, потому что так так работает Form.createFormField
      const newData = _.mapValues(_.clone(flatData), (val) => ({ value: val }));
      return {...state, data: {...state.data, ...initialState.data, ...newData}, isLoading: false}
    },

    [sendRequest]: (state) => ({ ...state }),
    [sendSuccess]: (state) => ({ ...state }),
    [sendFailure]: (state) => ({ ...state }),

    [change]: (state, data) => ({ ...state, data: {...state.data, ...data}}),
  }, 
  initialState
)



// WEBPACK FOOTER //
// ./src/ducks/settings.js